import {
	CardElement,
	AddressElement,
	useStripe,
	useElements,
} from "@stripe/react-stripe-js";
import { useState } from "react";
import { useNavigate } from "react-router";
import LoaderComponent from "../loader/LoaderComponent";
import matrimonyInstance from "../../utils/axios";
import { PAYMENT_VIA_LINK, PAYMENT_VIA_PROFILE } from "../../API_LIST";
import { useSelector } from "react-redux";

const staticToken = localStorage.getItem("jwtToken");
const BAT_ACCOUNT = "BAT";
const MATRIMONY_ACCOUNT = "MM";
const BAT_ACCOUNT_STRIPE_ID = "price_1R956oJaMQuVGZe3PVFyBfKg";
const MATRIMONY_ACCOUNT_STRIPE_ID = "price_1R957jJaMQuVGZe3cwYWMasu";
const UPGRADE_ACCOUNT_TYPE = "upgrade";

const SubscriptionForm = ({ profileId, accountEmail, type }) => {
	const stripe = useStripe();
	const elements = useElements();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [paymentData, setPaymentData] = useState(null);
	const navigate = useNavigate();
	const paymentDetails = useSelector((state) => state.payment.paymentDetails);

	const handlePaymentDetailsChange = (event) => {
		if (event.complete && event.value) {
			setPaymentData(event.value);
		}
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		if (!stripe || !elements) return;

		setError(null);
		setLoading(true);

		const cardElement = elements.getElement(CardElement);

		const { error: paymentMethodError, paymentMethod } =
			await stripe.createPaymentMethod({
				type: "card",
				card: cardElement,
				billing_details: {
					name: paymentData?.name,
					address: paymentData?.address,
				},
			});

		if (paymentMethodError) {
			setError(paymentMethodError.message);
			setLoading(false);
			return;
		}

		try {
			let apiEndpoint;
			let paymentValue;
			if (profileId && accountEmail) {
				apiEndpoint = PAYMENT_VIA_PROFILE;
				if (type === UPGRADE_ACCOUNT_TYPE) {
					paymentValue = {
						email: accountEmail,
						profile_id: profileId,
						stripePriceId: MATRIMONY_ACCOUNT_STRIPE_ID,
						paymentMethodId: paymentMethod.id,
						type: UPGRADE_ACCOUNT_TYPE,
					};
				} else {
					paymentValue = {
						email: accountEmail,
						profile_id: profileId,
						stripePriceId: MATRIMONY_ACCOUNT_STRIPE_ID,
						paymentMethodId: paymentMethod.id,
					};
				}
			} else {
				if (paymentDetails.type === BAT_ACCOUNT) {
					paymentValue = {
						email: paymentDetails.account_email,
						profile_id: paymentDetails.account_id,
						stripePriceId: BAT_ACCOUNT_STRIPE_ID,
						paymentMethodId: paymentMethod.id,
						type: paymentDetails.type,
					};
				} else if (paymentDetails.type === MATRIMONY_ACCOUNT) {
					paymentValue = {
						email: paymentDetails.account_email,
						profile_id: paymentDetails.profile_id,
						stripePriceId: MATRIMONY_ACCOUNT_STRIPE_ID,
						paymentMethodId: paymentMethod.id,
						type: paymentDetails.type,
					};
				}
				apiEndpoint = PAYMENT_VIA_LINK;
			}

			const response = await matrimonyInstance.post(apiEndpoint, paymentValue);

			if (response?.status === 200) {
				setLoading(false);
				if (profileId && accountEmail) {
					navigate("/dashboard/payment-done");
				} else {
					navigate("/payment-done");
				}
			} else {
				throw new Error("Failed to process payment");
			}
		} catch (error) {
			setError("An error occurred while processing payment. Please try again.");
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="card-container">
			{loading && <LoaderComponent />}
			<h3 className="mb-20 text-center">Payment Details</h3>
			<h4 className="mb-20 text-center">
				{paymentDetails?.type === BAT_ACCOUNT
					? "BAT Account Fee: $150"
					: type === UPGRADE_ACCOUNT_TYPE
						? "Upgrade to BAT membership: $150"
						: "Matrimony Profile Fee: $50"}
			</h4>
			<form onSubmit={handleSubmit}>
				<CardElement className="StripeElement mb-20" />
				<AddressElement
					onChange={handlePaymentDetailsChange}
					options={{ mode: "billing" }}
					className="mb-20"
				/>
				{error && <div className="text-danger my-2">{error}</div>}
				<button
					type="submit"
					className="button payment-btn w-100"
					disabled={loading || !stripe}
				>
					{loading ? "Processing..." : "Subscribe"}
				</button>
			</form>
		</div>
	);
};

export default SubscriptionForm;
